import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 3,
  class: "other"
}
const _hoisted_2 = {
  key: 4,
  class: "other"
}
const _hoisted_3 = {
  key: 5,
  class: "other"
}
const _hoisted_4 = {
  key: 6,
  class: "other"
}
const _hoisted_5 = {
  key: 7,
  class: "other"
}
const _hoisted_6 = {
  key: 8,
  class: "other"
}
const _hoisted_7 = {
  key: 9,
  class: "other"
}
const _hoisted_8 = {
  key: 10,
  class: "other"
}
const _hoisted_9 = {
  key: 11,
  class: "other"
}
const _hoisted_10 = {
  key: 12,
  class: "other"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_person_info = _resolveComponent("person-info")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.checked.includes(14) && _ctx.name == 14)
      ? (_openBlock(), _createBlock(_component_person_info, {
          key: 0,
          name: 14
        }))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(15) && _ctx.name == 15)
      ? (_openBlock(), _createBlock(_component_person_info, {
          key: 1,
          name: 15
        }))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(16) && _ctx.name == 16)
      ? (_openBlock(), _createBlock(_component_person_info, {
          key: 2,
          name: 16
        }))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(1) && _ctx.name == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[19] || (_cache[19] = _createElementVNode("div", { class: "sub-title" }, "请确认取得《开户同意信》，否则您无法开通账户：", -1)),
          _createVNode(_component_van_field, {
            name: "company",
            modelValue: _ctx.formInfo.disclosure1,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formInfo.disclosure1) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode1Blur,
            maxlength: "100",
            placeholder: "请输入公司名称",
            rules: [{ required: true, message: '请输入公司名称' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "company",
            modelValue: _ctx.formInfo.disclosure2,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formInfo.disclosure2) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode1Blur,
            maxlength: "100",
            placeholder: "请输入中央编号/金管局注册号码",
            rules: [{ required: true, message: '请输入中央编号/金管局注册号码' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "uploader",
            class: "open-upload",
            rules: [{ required: true, message: '请上传开户同意信' }]
          }, {
            input: _withCtx(() => [
              _createVNode(_component_van_uploader, {
                modelValue: _ctx.openFile,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.openFile) = $event)),
                "before-read": _ctx.beforeRead,
                accept: ".pdf,image/*",
                "max-count": "1",
                "preview-size": "86",
                onClick: _ctx.uploadToApp,
                readonly: _ctx.isApp
              }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("div", { class: "upload-style" }, [
                    _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }),
                    _createElementVNode("p", null, "开户同意信")
                  ], -1)
                ])),
                _: 1
              }, 8, ["modelValue", "before-read", "onClick", "readonly"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(2) && _ctx.name == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "sub-title" }, "请提供中央编号：", -1)),
          _createVNode(_component_van_field, {
            name: "no",
            modelValue: _ctx.formInfo2.disclosure1,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formInfo2.disclosure1) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            placeholder: "请输入中央编号",
            onBlur: _ctx.onCode2Blur,
            rules: [{ required: true, message: '请输入中央编号' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(3) && _ctx.name == 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "sub-title" }, "请提供有关人士资料：", -1)),
          _createVNode(_component_van_field, {
            name: "realate",
            modelValue: _ctx.formInfo3.disclosure1,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formInfo3.disclosure1) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            onBlur: _ctx.onCode3Blur,
            placeholder: "请输入姓名",
            rules: [{ required: true, message: '请输入姓名' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "realation",
            modelValue: _ctx.formInfo3.disclosure2,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formInfo3.disclosure2) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            placeholder: "请输入关系",
            onBlur: _ctx.onCode3Blur,
            rules: [{ required: true, message: '请输入关系' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(4) && _ctx.name == 4)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "sub-title" }, "请提供有关公司资料：", -1)),
          _createVNode(_component_van_field, {
            name: "company2",
            modelValue: _ctx.formInfo4.disclosure1,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formInfo4.disclosure1) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            placeholder: "请输入公司名称",
            onBlur: _ctx.onCode4Blur,
            rules: [{ required: true, message: '请输入公司名称' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "disclosure2",
            modelValue: _ctx.formInfo4.disclosure2,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formInfo4.disclosure2) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            onBlur: _ctx.onCode4Blur,
            placeholder: "请输入上市编号",
            rules: [{ required: true, message: '请输入上市编号' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(5) && _ctx.name == 5)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "sub-title" }, "请提供有关人士资料：", -1)),
          _createVNode(_component_van_field, {
            name: "relationship",
            modelValue: _ctx.formInfo5.disclosure1,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formInfo5.disclosure1) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            onBlur: _ctx.onCode5Blur,
            placeholder: "请输入该政治人物的姓名",
            rules: [{ required: true, message: '请输入该政治人物的姓名' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "relationship",
            modelValue: _ctx.formInfo5.disclosure2,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formInfo5.disclosure2) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            onBlur: _ctx.onCode5Blur,
            placeholder: "请输入关系",
            rules: [{ required: true, message: '请输入关系' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "relationship",
            modelValue: _ctx.formInfo5.disclosure3,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formInfo5.disclosure3) = $event)),
            modelModifiers: { trim: true },
            maxlength: "100",
            onBlur: _ctx.onCode5Blur,
            placeholder: "请输入地方及所担任的公职",
            rules: [{ required: true, message: '请输入地方及所担任的公职' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(6) && _ctx.name == 6)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_van_field, {
            name: "other",
            modelValue: _ctx.formInfo6.disclosure1,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formInfo6.disclosure1) = $event)),
            modelModifiers: { trim: true },
            placeholder: "请注明",
            maxlength: "100",
            onBlur: _ctx.onCode6Blur,
            rules: [{ required: true, message: '请注明' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(8) && _ctx.name == 8)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createVNode(_component_van_field, {
            name: "othe3",
            class: "other",
            modelValue: _ctx.formInfo8.disclosure1,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formInfo8.disclosure1) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode8Blur,
            placeholder: "请注明",
            maxlength: "100",
            rules: [{ required: true, message: '请注明' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(27) && _ctx.name == 27)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_van_field, {
            name: "othe27",
            class: "other",
            modelValue: _ctx.formInfo27.disclosure1,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formInfo27.disclosure1) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode27Blur,
            placeholder: "请注明",
            maxlength: "100",
            rules: [{ required: true, message: '请注明' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(24) && _ctx.name == 24 && _ctx.idKind !== 2 && _ctx.idKind !== 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_van_field, {
            name: "othe3",
            class: "other",
            modelValue: _ctx.formInfo24.disclosure1,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formInfo24.disclosure1) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode24Blur,
            placeholder: "请注明香港证件号码",
            maxlength: "100",
            rules: [{ required: true, message: '请注明' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.checked.includes(29) && _ctx.name == 29)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_van_field, {
            name: "othe29disclosure1",
            class: "other",
            modelValue: _ctx.formInfo29.disclosure1,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formInfo29.disclosure1) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode29Blur,
            placeholder: "请输入账号名称",
            maxlength: "100",
            rules: [{ required: true, message: '请输入账号名称' }]
          }, null, 8, ["modelValue", "onBlur"]),
          _createVNode(_component_van_field, {
            name: "othe29disclosure2",
            class: "other",
            modelValue: _ctx.formInfo29.disclosure2,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formInfo29.disclosure2) = $event)),
            modelModifiers: { trim: true },
            onBlur: _ctx.onCode29Blur,
            placeholder: "请输入账号号码",
            maxlength: "100",
            rules: [{ required: true, message: '请输入账号号码' }]
          }, null, 8, ["modelValue", "onBlur"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_action_sheet, {
      show: _ctx.fileActionState,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fileActionState) = $event)),
      actions: _ctx.actionsList,
      "cancel-text": "取消",
      "close-on-click-action": "",
      onSelect: _ctx.onFileSelect
    }, null, 8, ["show", "actions", "onSelect"])
  ], 64))
}